// extracted by mini-css-extract-plugin
export default {"spinner":"sQ4t1","error":"iZbNs"};